import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: Home
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
{ path: '/',  redirect: "/dashboard", component: () => import('@/views/Admin/index.vue'),
    children: [
        {
            path: 'login', 
            component: () => import('@/views/Admin/Login.vue') 
        },
        {
            path: 'dashboard',
            name: "Dashboard",
            component: () => import('@/views/Admin/Dashboard/index.vue')
        },
        {
            path: 'music-lists',
            name: 'Music Lists',
            component: () => import('@/views/Admin/MusicLists/index.vue')
        },
        {
            path: '/pending-signup-users',
            name: 'Pending Signup Users',
            component: () => import('@/views/Admin/PedingSignupUsers/index.vue')
        },
        {
            path: 'access-control',
            name: 'Access Control',
            component: () => import('@/views/Admin/AccessControl.vue')
        },
        {
            path: 'roles-manager',
            name: 'Roles Manager',
            component: () => import('@/views/Admin/RoleManager/index.vue')
        },
        {
            path: 'exp-tables-manager',
            name: 'EXP Tables Manager',
            component: () => import('@/views/Admin/EXPTablesManager/index.vue')
        },
        {
            path: 'api-control',
            name: 'API Access Manager',
            component: () => import('@/views/Admin/APIAccessControl/index.vue')
        },
        // Push Notification Manager
        {
            path: 'push-notification-manager',
            name: 'Push Notification Manager',
            component: () => import('@/views/Admin/PushNotificationManager/index.vue')
        },
        {
            path: 'email-template-manager',
            name: 'Email template Manager',
            component: () => import('@/views/Admin/EmailTemplateManager/index.vue')
        },
        {
            path: 'logic-control',
            name: 'Logic Control',
            component: () => import('@/views/Admin/LogicControl/index.vue')
        },
        {
            path: 'quest-manager',
            name: 'Quest Manager',
            component: () => import('@/views/Admin/QuestManager/index.vue')
        },
        {
            path: 'artists-manager',
            name: 'Artists Manager',
            component: () => import('@/views/Admin/ArtistsManager/index.vue')
        },
        {
            path: 'labels-lists',
            name: 'Label Lists',
            component: () => import('@/views/Admin/LabelLists.vue')
        },
        {
            path: 'groups-lists',
            name: 'Group Lists',
            component: () => import('@/views/Admin/GroupLists.vue')
        },
        {
            path: 'campaign-manager',
            name: 'Campaign Manager',
            component: () => import('@/views/Admin/CampaignManager.vue')
        },
        {
            path: 'campaign-analytics',
            name: 'Campaign Analytics',
            component: () => import('@/views/Admin/CampaignAnalytics.vue')
        },
        {
            path: 'group-settings',
            name: 'Group Settings',
            component: () => import('@/views/Admin/GroupSettings.vue')
        },
        {
            path: 'individual-campaign-settings',
            name: 'Individual Campaign Settings',
            component: () => import('@/views/Admin/IndividualCampaignSettings.vue')
        },
        {
            path: 'campaign-settings',
            name: 'Campaign Settings',
            component: () => import('@/views/Admin/CampaignSettings.vue')
        },
        {
            path: 'user-token-manager',
            name: 'User Token Manager',
            component: () => import('@/views/Admin/UserTokenManager.vue')
        },
        {
            path: 'token-rate-manager',
            name: 'Token Rate Manager',
            component: () => import('@/views/Admin/TokenRateManager.vue')
        },
        {
            path: 'survey-manager',
            name: 'Survey Manager',
            component: () => import('@/views/Admin/SurveyManager/index.vue')
        },
        {
            path: 'label-campaign-manager',
            name: 'Label Campaign Manager',
            component: () => import('@/views/Admin/LabelCampaignManager/index.vue')
        },
        {
            path: 'promo-code-manager',
            name: 'Promo Code Manager',
            component: () => import('@/views/Admin/PromoManager/index.vue')
        },
        {
            path: 'item-marketplace-database',
            name: 'Items/Marketplace Manager',
            component: () => import('@/views/Admin/ItemDatabase/index.vue')
        },
        {
            path: 'points-manager',
            name: 'Points Manager',
            component: () => import('@/views/Admin/PointsManager/index.vue')
        },
        {
            path: 'profile-templates',
            name: 'Profile Templates',
            component: () => import('@/views/Admin/ProfileTemplate/index.vue')
        },
        {
            path: 'toluna-manager',
            name: 'Toluna Manager',
            component: () => import('@/views/Admin/TolunaManager/index.vue')
        },
        {
            path: 'settings',
            redirect: "/settings/sidebar-banner",
            component: () => import('@/views/Admin/Settings/index.vue'),
            children: [
                {
                    path: 'sidebar-banner',
                    name: 'Sidebar Banner',
                    component: () => import('@/views/Admin/Settings/SidebarBanner.vue')
                },
                {
                    path: 'listing-settings',
                    name: 'Listing Settings',
                    component: () => import('@/views/Admin/Settings/ListingSettings.vue')
                },
                {
                    path: 'community-filters',
                    name: 'Community Filters',
                    component: () => import('@/views/Admin/Settings/CommunityFilters.vue')
                },
                {
                    path: 'mobile-banners',
                    name: 'Mobile Banners',
                    component: () => import('@/views/Admin/Settings/MobileBannerManager.vue')
                },
                {
                    path: 'mobile-mini-banner',
                    name: 'Mini Mobile Banner',
                    component: () => import('@/views/Admin/Settings/MiniMobileBannerManager.vue')
                }
            ]
        }
    ]}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
